import { Directive, HostBinding, HostListener } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { NeedHelpBottomSheetComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help-bottom-sheet.component';

@Directive({
  selector: '[xNeedHelp]',
})
export class NeedHelpDirective {
  @HostBinding('class.need-help-action')
  needHelp = true;

  @HostListener('click', ['$event.target'])
  onClick(btn: any) {
    this.bottomSheet.open(NeedHelpBottomSheetComponent);
  }

  constructor(private bottomSheet: MatBottomSheet) {}
}
